import { FunctionComponent, useState } from "react";

import { DefaultButton, Dialog } from "@bps/fluent-ui";
import { EnableUserForm } from "@libs/api/gateways/bp-id/EnableUserForm";

interface EnableOrDisableUserButtonProps {
  bpIdUserId: string;
  userName: string;
  accountEnabled: boolean;
}

export const EnableOrDisableUserButton: FunctionComponent<EnableOrDisableUserButtonProps> = ({
  bpIdUserId,
  userName,
  accountEnabled
}) => {
  const [showEnabledDialog, setShowEnabledDialog] = useState<boolean>(false);

  return (
    <>
      {showEnabledDialog && (
        <Dialog hidden={false}>
          <EnableUserForm
            bpIdUserId={bpIdUserId}
            userName={userName}
            enable={!accountEnabled}
            onSubmit={() => setShowEnabledDialog(false)}
          />
        </Dialog>
      )}
      <DefaultButton onClick={() => setShowEnabledDialog(true)}>
        {accountEnabled ? "Disable User" : "Enable User"}
      </DefaultButton>
    </>
  );
};
